import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { contestActions } from '../../store/contest/contestSlice';
import { selectPageConfig } from '../../store/selectors/selectPageConfig';
import { fetchContestData } from '../../store/contest/contest-actions';
import { ContestError } from './contestPageState/ContestPageState';
import { finalPageAvailable, isIdentified, moveUserToFinalPage, teamMember } from '../../ui/builders/utils';
import Tabs from '../../components/tabs/Tabs';
import SectionTabs from './sectionsTabs/SectionTabs';
import classes from './ContestPage.module.css';

const ContestPage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { contestId } = useParams();
  const pageConfig = useSelector(selectPageConfig);
  const { authState, school, isAuth, initAuthDetails } = useSelector(state => state.auth);
  const contest = useSelector(state => state.contest);
  const { error, isLoading } = useSelector(state => state.contest);
  const scrollRef = useRef(null);
  const identified = isIdentified(authState);
  const [activeTabId, setActiveTabId] = useState(pageConfig?.tabs?.[0]?.id);

  useEffect(() => {
    if (!contest?.finalStatus || !contest?.finalData)
      return;
    if (teamMember(contest) && finalPageAvailable(contest) && contest?.moveUserToFinalPage) {
      dispatch(contestActions.setMoveUserToFinalPage(false));
      navigate('/finalPage', { state: { navigation: 'InitiatedTransferWithUserInteraction' } });
    }
  }, [contest?.finalStatus, contest?.finalData]);

  useEffect(() => {
    if (!contestId || initAuthDetails !== true || isAuth == null)
      return;
    dispatch(fetchContestData(isAuth, school?.id, contestId));
  }, [dispatch, contestId, initAuthDetails, isAuth, school]);

  useEffect(() => {
    if (!activeTabId && pageConfig?.tabs?.length)
      setActiveTabId(pageConfig.tabs[0].id);
  }, [pageConfig, activeTabId]);

  const handleTabClick = (tabId) => {
    setActiveTabId(tabId);
    const container = scrollRef.current;
    if (!container)
      return;
    const tab = pageConfig?.tabs?.find(t => t.id === tabId);
    const firstAnchorId = tab?.sections?.[0]?.anchorId;
    if (firstAnchorId) {
      const el = container.querySelector(`#${CSS.escape(firstAnchorId)}`);
      if (el)
        container.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
    }
  };


  const renderContent = () => {

    if (isLoading)
      return (
        <div className={classes.loadingWrapper}>
          <div className={classes.loadingScreen}>
            <div className={classes.loadingContent}>
              <div className={classes.loadingSpinner}>⏳</div>
              <p>טוען נתונים...</p>
            </div>
          </div>
        </div>
      );

    if (error)
      return <ContestError error={error} />;

    return (
      <>
        {pageConfig &&
          <div className={`${classes.contestPage} ${!identified ? classes.unidentified : ''}`}>
            <Tabs tabs={pageConfig.tabs} onTabClick={handleTabClick} activeTabId={activeTabId} />
            <SectionTabs tabs={pageConfig.tabs} scrollRef={scrollRef} onScrollFunc={() => { }} />
          </div>
        }
      </>
    );
  };

  return renderContent();
}

export default ContestPage;
